<script lang="ts">
  import { VStack } from '@/ui/base/stack';
  import CTAButton from '@/ui/elements/buttons/CTAButton.svelte';
  import TeoBall from '@/ui/elements/teo-ball/TeoBall.svelte';
  import { useTextUIActions } from '@/utils/teo-context/teo-atoms/text';

  import { useAuthState } from '../auth/use-auth.svelte';

  const { setSelectedUIView } = useTextUIActions();
  const authState = useAuthState();
  const { user } = $derived(authState.current);
  function handleEditorClick() {
    setSelectedUIView('performance');
  }

  function handleGeneratorClick() {
    setSelectedUIView('text-generator');
  }
</script>

<div class="absolute flex h-[90%] w-[90%] min-w-[750px] items-center justify-center bg-transparent">
  <div class="flex items-center justify-center">
    <div class="flex-1">
      <TeoBall variant="idle-right" class="w-[250px] translate-x-[-100px]" />
    </div>
    <div class="flex flex-col items-center gap-6 rounded-md bg-white p-6 shadow-card">
      <VStack gap={6} class="f-1 h-full min-w-profile justify-between">
        <VStack gap={3} xalign="center">
          <h1 class="text-title font-semibold">Hi {user?.firstName}!</h1>
          <p class="text-center">Wobei kann ich dir helfen?</p>
        </VStack>
        <VStack gap={4} xalign="center" yalign="center" class="f-1">
          <CTAButton
            class="!text-md"
            iconLeft="AutoAwesome"
            variant="generate"
            onclick={handleGeneratorClick}>Text erstellen</CTAButton
          >
          <CTAButton iconLeft="TachoSymbol" variant="analyze" onclick={handleEditorClick}
            >Text optimieren</CTAButton
          >
        </VStack>
      </VStack>
    </div>
  </div>
</div>
